<div class="container" *ngIf="loading">
  <div class="loading-icon-bubbles">Loading...</div>
</div>

<div class="container" fxLayout="column" *ngIf="!loading">
  <h1 *ngIf="forgotPasswordUserName">Set New Password</h1>
  <h2 *ngIf="!forgotPasswordUserName && selectedMailbox">Update the password for: <br/>{{selectedMailbox.emailAddress}}</h2>
  <h2 *ngIf="!forgotPasswordUserName && !selectedMailbox">Change password</h2>

  <mat-card class="information-alert" *ngIf="!forgotPasswordUserName">
    <h4>Please Note</h4>
    <p>If you change your password, you’ll need to update it on any devices that have the old password saved (e.g. saved logins in web browsers).</p>
    <p *ngIf="hasLinkedIasAccount"><strong>Important:</strong> This page will only change the password for this My Account portal. To change the password for your other services managed in our legacy portal, select ‘Switch Account’ and log in with your existing details.</p>
  </mat-card>
  <form [formGroup]="passwordForm" fxLayout="column" *ngIf="(commonDataService.siteDetails$ | async)?.maxPasswordLength">
    <mat-form-field appearance="outline" class="standard-input" *ngIf="shouldDisplayCurrentPassword">
      <mat-label *ngIf="!forgotPasswordUserName">Current Password</mat-label>
      <mat-label *ngIf="forgotPasswordUserName">Old Password</mat-label>
      <input matInput formControlName="currentPassword" [type]="hideCurrentPw?'password':'text'" placeholder="{{forgotPasswordUserName? 'Old Password' : 'Current Password'}}"/>
      <button matSuffix mat-icon-button (click)="hideCurrentPw = !hideCurrentPw" tabindex="-1"><mat-icon>{{hideCurrentPw? 'visibility_off' : 'visibility'}}</mat-icon></button>
    </mat-form-field>
    <mat-form-field appearance="outline" class="standard-input password">
      <mat-label>New Password</mat-label>
      <input matInput formControlName="newPassword" [type]="hideNewPw?'password':'text'" placeholder="New Password"/>
      <button matSuffix mat-icon-button (click)="hideNewPw = !hideNewPw" tabindex="-1"><mat-icon>{{hideNewPw? 'visibility_off' : 'visibility'}}</mat-icon></button>
      <mat-hint *ngIf="!passwordForm.controls['newPassword'].errors">
        Your password is secure
      </mat-hint>
    </mat-form-field>
    <div id="password-requirements" fxLayout="row" fxLayoutAlign="space-between" *ngIf="passwordForm.controls['newPassword'].errors">
      <ul>
        <li [ngClass]="passwordForm.controls['newPassword'].errors.containsCorrectLength? 'failed':'passed'">8 to {{commonDataService.siteDetails.maxPasswordLength}} characters long</li>
        <li [ngClass]="passwordForm.controls['newPassword'].errors.containsLowerCase? 'failed':'passed'">Lowercase letter</li>
        <li [ngClass]="passwordForm.controls['newPassword'].errors.containsUpperCase? 'failed':'passed'">Uppercase letter</li>
      </ul>
      <ul>
        <li [ngClass]="passwordForm.controls['newPassword'].errors.containsNumber? 'failed':'passed'">Contains a number(0-9)</li>
        <li [ngClass]="passwordForm.controls['newPassword'].errors.notBasedOnUsername? 'failed':'passed'">Not your username</li>
        <li [ngClass]="passwordForm.controls['newPassword'].errors.notContainsSpacedOrTabs? 'failed':'passed'">No spaces</li>
      </ul>
    </div>
    <mat-form-field appearance="outline" class="standard-input password">
      <mat-label>Confirm Password</mat-label>
      <input matInput type="password" formControlName="confirmPassword" placeholder="Confirm Password"/>
      <mat-error *ngIf="passwordForm.controls['confirmPassword'].errors && !passwordForm.controls['confirmPassword'].errors.confirmPasswordFail">{{constants.CONFIRM_PASSWORD_EMPTY_ERROR}}</mat-error>
      <mat-error *ngIf="passwordForm.controls['confirmPassword'].errors && passwordForm.controls['confirmPassword'].errors.confirmPasswordFail">{{constants.PASSWORD_MISMATCH_ERROR}}</mat-error>
      <mat-hint *ngIf="!passwordForm.controls['confirmPassword'].errors">Passwords match!</mat-hint>
    </mat-form-field>
  </form>
  <div fxLayout.xs="column" fxLayout.gt-xs="row" ngClass.gt-xs="form-row-container">
    <div  fxFlex.xs="100" fxFlexOrder.gt-xs="2" matTooltip="{{constants.MULTIPLE_FIELDS_TOOLTIP}}" [matTooltipDisabled]="!passwordForm.invalid && passwordForm.dirty" matTooltipPosition="above">
      <button color="warn" mat-raised-button (click)="submitPassword()" [disabled]="(passwordForm.invalid || !passwordForm.dirty)">Change password</button>
    </div>
    <span fxFlexOrder.gt-xs="1" fxFlex="" fxHide.xs=""></span>
    <button fxFlexOrder.gt-xs="0" mat-raised-button (click)="cancel()">Cancel</button>
  </div>
</div>
